"use client";

import type { AdyenCheckoutError, PaymentFailedData } from "@adyen/adyen-web";
import { useEffect, useState } from "react";

import { adyenStore } from "./Adyen.store";
import AdyenErrorMessage from "./AdyenErrorMessage";

const AdyenWidgetError = () => {
  const [error, setError] = useState<
    PaymentFailedData | AdyenCheckoutError | Error | null | undefined
  >();

  useEffect(() => {
    adyenStore.subscribe(
      (state) => state.adyenDropInError,
      (adyenDropInError) => {
        setError(adyenDropInError);
      },
    );
  }, []);

  if (!error) {
    return null;
  }

  if ("resultCode" in error) {
    return <AdyenErrorMessage resultCode={error.resultCode} />;
  }

  if ("message" in error) {
    return <AdyenErrorMessage message={error.message} />;
  }
};

export default AdyenWidgetError;
